import { type Entity, type ID } from 'src/lib/collection';

export const COMPLIANCE_ENTITY = {
  variation: 'variation',
  longFormAsset: 'long_form_asset',
  blogDraft: 'blog_draft',
} as const;
export type ComplianceEntity = (typeof COMPLIANCE_ENTITY)[keyof typeof COMPLIANCE_ENTITY];

export const COMPLIANCE_STATUS = {
  created: 'created',
  processing: 'processing',
  done: 'done',
  doneWithErrors: 'done_with_errors',
  applied: 'applied',
} as const;
export type ComplianceStatus = (typeof COMPLIANCE_STATUS)[keyof typeof COMPLIANCE_STATUS];

export interface ComplianceData {
  status: ComplianceStatus;
  progress: number;
}

export interface EntityComplianceData extends Entity {
  complianceStatus: ComplianceStatus;
  complianceProgressPercentage: number;
}

export const isInProgressComplianceStatus = (status?: ComplianceStatus): boolean =>
  status === COMPLIANCE_STATUS.created || status === COMPLIANCE_STATUS.processing;

export const isCompletedComplianceStatus = (status?: ComplianceStatus): boolean =>
  status === COMPLIANCE_STATUS.done || status === COMPLIANCE_STATUS.doneWithErrors;

export const isAppliedComplianceStatus = (status?: ComplianceStatus): boolean =>
  status === COMPLIANCE_STATUS.applied;

interface ComplianceState {
  prePollingIds: Set<ID>;
  pollingIds: Set<ID>;
  results: EntityComplianceData[];
}
export const getComplianceData = (
  entityId: ID,
  complianceState: ComplianceState
): ComplianceData | undefined => {
  const complianceEntity = complianceState.results.find((item) => item.id === entityId);
  if (complianceEntity) {
    return {
      status: complianceEntity.complianceStatus,
      progress: complianceEntity.complianceProgressPercentage,
    };
  }

  if (complianceState.prePollingIds.has(entityId)) {
    return {
      status: COMPLIANCE_STATUS.created,
      progress: 1,
    };
  }

  if (complianceState.pollingIds?.has(entityId)) {
    return {
      status: COMPLIANCE_STATUS.processing,
      progress: 1,
    };
  }

  return undefined;
};
